export default __webpack_public_path__ + "static/media/t_shirt_blue_reduced.b8bb6e54.jpg";